import React, {Component, Fragment} from 'react';
import { Form, Row, Col, Input, Select, InputNumber, Button, Divider, Checkbox, Tooltip, Icon, Slider, Modal } from 'antd';
import {inject, observer} from "mobx-react/index";
import { withRouter } from 'react-router-dom';

const Option = Select.Option;
const exchangesRequirePassword = ['kucoin', 'coinbasepro'];

@withRouter
@inject('store')
@observer
class GeneralFormComponent extends Component {

    constructor(props) {
        super(props) ;
        this.state = {
            showPositionCalculator: false,
            split: 50,
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.store.botStore.updateConfig(values);
            }
        });

        let payload = { ...this.state };
        delete payload.strategies;
    }

    render() {
        const { getFieldDecorator, getFieldValue, setFieldsValue } = this.props.form;
        const exchangeConfig = this.props.store.exchangeConfig[this.props.store.botStore.currentConfiguration.exchange];
        const baseCurrency = getFieldValue("base_currency");
        const base_allocation_total = getFieldValue("base_allocation_total");
        const base_allocation_percent = getFieldValue("base_allocation_percent");
        const reserve_allocation = getFieldValue("reserve_allocation") || 0;
        const minimum_order_amount = getFieldValue("minimum_order_amount");
        const baseAllocationPercentValue = (base_allocation_total * base_allocation_percent / 100);
        const totalPossiblePositions = (base_allocation_total / (baseAllocationPercentValue > 0 ? baseAllocationPercentValue : minimum_order_amount)).toFixed(0) || 0;
        const investmentAmount = this.state.totalInvestment || (base_allocation_total+reserve_allocation);
        const share = (investmentAmount/100);
        getFieldDecorator('selected_symbols');
        return (
            <Fragment>
                <Row gutter={24}>
                    <Col md={12}>
                        <Form.Item label="Name" required={true}>
                            {getFieldDecorator('name', {
                                rules: [{ required: true, message: 'Field is required' }]
                            })(
                                <Input />
                            )}
                        </Form.Item>
                    </Col>

                    <Col md={12}>
                        <Form.Item label={<span>Mode <Tooltip placement="right" title={'Trade live on an exchange or on Paper'}>
                            <Icon type="info-circle" theme="outlined" />
                        </Tooltip></span>}>
                            {getFieldDecorator('mode', {
                                initialValue: 'test'
                            })(
                                <Select>
                                    {
                                        exchangeConfig.modes.map((mode) => <Option value={mode.id} key={mode.id}>{mode.name}</Option>)
                                    }
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Divider orientation="left">Strategies</Divider>
                    <Col md={8}>
                        <Form.Item label="Buy & Sell">
                            {getFieldDecorator('strategy_id', {
                        })(
                            <Select showSearch style={{width: "100%"}} filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} optionFilterProp="name">
                                { this.props.store.strategyStore.buySell.slice().sort((a, b) => {
                                    if(a.name < b.name) return -1;
                                    if(a.name > b.name) return 1;
                                    return 0;
                                }).map((s) => {
                                    return <Option value={s.id} key={s.id}>{s.name}</Option>
                                })}
                            </Select>
                        )}
                        </Form.Item>
                    </Col>

                    <Col md={8}>
                        <Form.Item label="Auto Dollar Cost Averaging">
                            {getFieldDecorator('adca_strategy_id', {
                                initialValue: ''
                            })(
                                <Select showSearch style={{width: "100%"}} filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} optionFilterProp="name">
                                    <Option value='' >None</Option>
                                    { this.props.store.strategyStore.adca.slice().sort((a, b) => {
                                        if(a.name < b.name) return -1;
                                        if(a.name > b.name) return 1;
                                        return 0;
                                    }).map((s) => {
                                        return <Option value={s.id} key={s.id}>{s.name}</Option>
                                    })}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>

                    <Col md={8}>
                        <Form.Item label="Auto Reverse Trading">
                            {getFieldDecorator('art_strategy_id', {
                                initialValue: ''
                            })(
                                <Select showSearch style={{width: "100%"}} filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} optionFilterProp="name">
                                    <Option value='' >None</Option>
                                    { this.props.store.strategyStore.art.slice().sort((a, b) => {
                                        if(a.name < b.name) return -1;
                                        if(a.name > b.name) return 1;
                                        return 0;
                                    }).map((s) => {
                                        return <Option value={s.id} key={s.id}>{s.name}</Option>
                                    })}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>

                    <Divider orientation="left">Investment </Divider>

                    <Col md={6}>
                        <Form.Item label={<span>Base Currency <Tooltip placement="right" title={'Base asset the bot will use to trade with'}>
                            <Icon type="info-circle" theme="outlined" />
                        </Tooltip></span>}>
                            {getFieldDecorator('base_currency', {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: "BTC"
                            })(
                                <Select style={{width: 100}} onChange={(base) => {

                                    switch(base) {
                                        case 'BTC':
                                            this.props.form.setFields({'minimum_order_amount': { value: 0.0012}});
                                            break;
                                        case 'ETH':
                                            this.props.form.setFields({'minimum_order_amount': { value: 0.012}});
                                            break;
                                        case 'XRP':
                                            this.props.form.setFields({'minimum_order_amount': { value: 11}});
                                            break;
                                        case 'BNB':
                                            this.props.form.setFields({'minimum_order_amount': { value: 1.2}});
                                            break;
                                        case 'USDT':
                                            this.props.form.setFields({'minimum_order_amount': { value: 12}});
                                            break;
                                        case 'TUSD':
                                            this.props.form.setFields({'minimum_order_amount': { value: 12}});
                                            break;
                                        case 'PAX':
                                            this.props.form.setFields({'minimum_order_amount': { value: 12}});
                                            break;
                                        case 'USDC':
                                            this.props.form.setFields({'minimum_order_amount': { value: 12}});
                                            break;
                                            default: //noop
                                    }
                                    this.props.form.setFields({'selected_symbols': { value: []}});

                                }}>
                                    { exchangeConfig.supported_base.map((base) => <Option value={base} key={base}>{base}</Option>) }
                                </Select>
                            )}
                        </Form.Item>
                    </Col>

                    <Col md={6}>
                        <Form.Item label={<span>Compound Profit and Loss <Tooltip placement="right" title={'After each trade profit/loss will be added to total position allocation'}>
                            <Icon type="info-circle" theme="outlined" />
                        </Tooltip></span>} >
                            {getFieldDecorator('compounding_allocation', {
                                valuePropName: 'checked',
                                initialValue: false
                            })(
                                <Checkbox />
                            )}
                        </Form.Item>
                    </Col>

                    <Col md={6}>
                        <Form.Item label={<span>Position Allocation <Tooltip placement="right" title={'These funds are used to open new positions'}>
                            <Icon type="info-circle" theme="outlined" />
                        </Tooltip></span>}>
                            {getFieldDecorator('base_allocation_total', {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 0.001
                            })(
                                <InputNumber min={0.001} style={{width: 200}}/>
                            )}

                            <Icon onClick={()=> this.setState({showPositionCalculator: true})} type="calculator" style={{fontSize: 18, color: '#a187ff', marginLeft: 10, cursor: 'pointer'}}/>
                        </Form.Item>
                    </Col>

                    <Col md={6}>
                        <Form.Item label={<span>Reserve Allocation <Tooltip placement="right" title={'These funds are used by the Manual/Auto DCA'}>
                            <Icon type="info-circle" theme="outlined" />
                        </Tooltip></span>}>
                            {getFieldDecorator('reserve_allocation', {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 0
                            })(
                                <InputNumber min={0} style={{width: 200}}/>
                            )}
                        </Form.Item>
                    </Col>

                    <Col md={6}>
                        <Form.Item label={<span>Position Allocation % split <Tooltip placement="right" title={'Percentage of allocation to be used to place orders, this is used if greater than the minimum order'}>
                            <Icon type="info-circle" theme="outlined" />
                        </Tooltip></span>}>
                            {getFieldDecorator('base_allocation_percent', {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 0
                            })(
                                <InputNumber />
                            )}
                            &nbsp;&nbsp;{((base_allocation_total * base_allocation_percent / 100) || 0).toFixed(8)} {baseCurrency} per position
                        </Form.Item>
                    </Col>

                    <Col md={6}>
                        <Form.Item label={<span>{baseCurrency} Minimum Order <Tooltip placement="right" title={'Ensure this is over the exchange minimum'}>
                            <Icon type="info-circle" theme="outlined" />
                        </Tooltip></span>}>
                            {getFieldDecorator('minimum_order_amount', {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 0.01
                            })(
                                <InputNumber style={{width: 200}} />
                            )}
                        </Form.Item>
                    </Col>

                    <Col md={6}>
                        <Form.Item label={<span>Maximum number of open positions</span>} extra={<span>Based on your total allocation you can hold <b>{totalPossiblePositions}</b> positions.</span>}>
                            {getFieldDecorator('max_positions', {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 50,
                            })(
                                <InputNumber max={75} />
                            )}
                        </Form.Item>
                    </Col>

                    <Col md={6}>
                        <Form.Item label="Total number of open positions per symbol">
                            {getFieldDecorator('max_symbol_positions', {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 2
                            })(
                                <InputNumber  />
                            )}
                        </Form.Item>
                    </Col>


                    <Divider orientation="left">API Keys</Divider>
                    <Col md={8}>
                        <Form.Item label="Api Key" >
                            {getFieldDecorator('api_key')(
                                <Input.Password/>
                            )}
                        </Form.Item>
                    </Col>

                    <Col md={8}>
                        <Form.Item label="Api Secret" >
                            {getFieldDecorator('api_secret')(
                                <Input.Password/>
                            )}
                        </Form.Item>
                    </Col>
                    {
                        exchangesRequirePassword.includes(getFieldValue("exchange")) ?
                            <Col md={8}>
                                <Form.Item label={<span>Api Passphrase <Tooltip placement="right" title={'This is not your trading password!'}><Icon type="info-circle" theme="outlined" />
                        </Tooltip></span>} >
                                    {getFieldDecorator('password')(
                                        <Input.Password/>
                                    )}
                                </Form.Item>
                            </Col>
                        : null
                    }
                </Row>
                <Button className={"btn-cta"} onClick={this.handleSubmit.bind(this)} type="primary" size="large">Save</Button>


                <Modal title="Funding Allocation" visible={this.state.showPositionCalculator} onOk={() => {
                    setFieldsValue({
                        base_allocation_total: share*this.state.split,
                        reserve_allocation: share*(100-this.state.split)
                    });
                    this.setState({showPositionCalculator: false});
                }} onCancel={()=> this.setState({showPositionCalculator: false})}>
                    <Input addonAfter={baseCurrency} value={investmentAmount} onChange={(e)=> this.setState({totalInvestment: parseFloat(e.target.value)})} />

                    <div style={{marginTop: 15}}>
                        <div>
                            <span style={{float: 'left', display: 'inline', width: 150}}>Position Allocation</span>
                            <span style={{float: 'right', textAlign: 'right', display: 'inline', width: 150}}>Reserve Allocation</span>
                        </div>
                        <div style={{clear: 'both'}}>
                            <Slider value={this.state.split} onChange={(value) => this.setState({split: value})}/>
                        </div>
                        <div style={{clear: 'both', marginTop:10, marginBottom:10}}>
                            <span style={{float: 'left', display: 'inline', width: 150}}>{(share*this.state.split).toFixed(8)}</span>
                            <span style={{float: 'right', textAlign: 'right', display: 'inline', width: 150}}>{(share*(100-this.state.split)).toFixed(8)}</span>
                        </div>
                        <span style={{clear: 'both'}}></span>
                    </div>

                </Modal>
            </Fragment>
        )
    }

}

export const GeneralForm = Form.create({
    mapPropsToFields: (props) => {
        const data = {};
        Object.keys(props.data || {}).forEach((k) => {
            if (k === 'api_key' || k === 'api_secret' || k === 'password') return;
            data[k] = Form.createFormField({value: props.data[k]})
        });
        return data;
    }
})(GeneralFormComponent)


// WEBPACK FOOTER //
// ./src/Account/Bot/SettingsView/GeneralForm.js